import React from 'react';
import { useSellerInfoContext } from '../../../context/SellerInfoContext';

export function SellerBadges() {
  const { Badges } = useSellerInfoContext();
  if (!Badges) return null;
  return <Badges />;
}
